import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const FullscreenView = () => {
  const [fullscreen1, setFullscreen1] = useState(false);
  const [fullscreen2, setFullscreen2] = useState(false);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* FULLSCREEN VIEWS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Fullscreen Views</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Image Fullscreen</label>
            <div className="relative w-full h-32 bg-slate-950 rounded border border-slate-600">
              <div className="absolute inset-0 bg-gradient-to-br from-amber-600 to-blue-600 rounded flex items-center justify-center"><span className="text-white font-semibold">Image</span></div>
              <button onClick={() => setFullscreen1(!fullscreen1)} className="absolute top-2 right-2 text-white text-lg bg-black/50 p-1 rounded">?</button>
              {fullscreen1 && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center" onClick={() => setFullscreen1(false)}><div className="relative w-4/5 h-4/5"><div className="w-full h-full bg-gradient-to-br from-amber-600 to-blue-600 rounded flex items-center justify-center"><span className="text-white font-bold text-2xl">Fullscreen Image</span></div><button className="absolute top-4 right-4 text-white text-2xl">?</button></div></div>
              }
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`const [fs, setFs] = useState(false);

return (
  <div className="relative">
    <img src="image.jpg" />
    <button onClick={() => setFs(!fs)}>?</button>
    {fs && (
      <div className="fixed inset-0 bg-black/90 z-50">
        <img src="image.jpg" className="w-full h-full" />
      </div>
    )}
  </div>
);`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Video Fullscreen</label>
            <div className="relative w-full h-32 bg-slate-950 rounded border border-slate-600">
              <div className="absolute inset-0 bg-gradient-to-br from-amber-600 to-amber-600 rounded flex items-center justify-center text-white">? Video</div>
              <button className="absolute top-2 right-2 text-white text-lg bg-black/50 p-1 rounded">?</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative w-full aspect-video bg-black rounded">
  <video src="video.mp4" controls className="w-full h-full" />
  <button className="absolute top-2 right-2">?</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Content Fullscreen</label>
            <div className="relative w-full h-32 bg-slate-950 rounded border border-slate-600 p-2">
              <div className="w-full h-full bg-slate-800 rounded flex items-center justify-center text-slate-300 text-sm">Content Area</div>
              <button className="absolute top-1 right-1 text-slate-300 text-lg">?</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative w-full h-screen bg-slate-900">
  <div className="p-4">Content goes here</div>
  <button className="absolute top-2 right-2">?</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Exit Fullscreen</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600 h-32 flex items-center justify-center">
              <div className="text-center"><div className="text-3xl mb-2">?</div><p className="text-slate-400 text-xs">Click to Exit</p></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`if (document.fullscreenElement) {
  document.exitFullscreen();
} else {
  element.requestFullscreen();
}`} />
          </div>
        </div>
      </div>

      {/* ADVANCED FULLSCREEN */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Fullscreen</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Presentation Mode</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-32 flex items-center justify-center">
              <div className="bg-gradient-to-b from-amber-900 to-slate-900 w-full h-full rounded flex flex-col items-center justify-center p-4">
                <p className="text-amber-200 font-bold text-sm">Slide 1 of 5</p>
                <p className="text-amber-200 text-xs mt-2">Press F5 to start</p>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-gradient-to-b from-amber-900 to-slate-900 h-screen flex flex-col items-center justify-center">
  <h1 className="text-4xl text-amber-200 mb-4">Title</h1>
  <p className="text-amber-200">Content</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Picture-in-Picture</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-32 relative">
              <div className="w-full h-full bg-slate-800 rounded flex items-center justify-center text-slate-400">Main Content</div>
              <div className="absolute bottom-2 right-2 w-16 h-12 bg-slate-700 rounded border border-slate-600"></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="w-full h-screen relative">
  <video src="main.mp4" />
  <video src="pip.mp4" className="absolute bottom-4 right-4 w-48 h-32" />
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullscreenView;


